import { useParams } from 'react-router-dom';
import { Link2 } from 'lucide-react';
import { useProducts } from '../hooks/useProducts';
import Toast from '../components/Toast';
import { useState } from 'react';
import styles from './ProfilePage.module.css';

const GRADIENTS = [
  'linear-gradient(135deg, #a8edea, #fed6e3)',
  'linear-gradient(135deg, #d299c2, #fef9d7)',
  'linear-gradient(135deg, #89f7fe, #66a6ff)',
  'linear-gradient(135deg, #f6d365, #fda085)',
  'linear-gradient(135deg, #a1c4fd, #c2e9fb)',
  'linear-gradient(135deg, #84fab0, #8fd3f4)',
];

function hashGradient(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) | 0;
  return GRADIENTS[Math.abs(h) % GRADIENTS.length];
}

export default function ProfilePage() {
  const { username } = useParams();
  const { products } = useProducts();
  const [toast, setToast] = useState(null);

  function handleProductClick(product) {
    if (product.url) {
      window.open(product.url, '_blank', 'noopener,noreferrer');
    }
  }

  function handleCopyLink() {
    navigator.clipboard.writeText(window.location.href).then(() =>
      setToast('링크 복사가 됐어요')
    );
  }

  return (
    <div className={styles.page}>
      {/* ─── Profile Header ─── */}
      <div className={styles.header}>
        <div className={styles.avatar}>
          <span className={styles.avatarInitial}>{username?.[0]?.toUpperCase() ?? '?'}</span>
          <div className={styles.avatarBadge}>🍳</div>
        </div>
        <p className={styles.username}>@{username}</p>
        <div className={styles.stats}>
          <div className={styles.stat}><strong>2,000</strong><span>팔로워</span></div>
          <div className={styles.statDivider} />
          <div className={styles.stat}><strong>129</strong><span>구독자</span></div>
        </div>
        <button className={styles.copyBtn} onClick={handleCopyLink}><Link2 size={15} strokeWidth={2} /> 링크 복사</button>
      </div>

      {/* ─── Tab Label ─── */}
      <div className={styles.tabBar}>
        <span className={styles.tabActive}>냉장고 {products.length}</span>
      </div>

      {/* ─── Product Grid ─── */}
      {products.length === 0 ? (
        <div className={styles.empty}>
          <span>🧊</span>
          <p>냉장고가 비어있어요</p>
        </div>
      ) : (
        <div className={styles.grid}>
          {products.map((p) => (
            <button
              key={p.id}
              className={styles.card}
              onClick={() => handleProductClick(p)}
            >
              <div className={styles.cardImg} style={{ background: hashGradient(p.id) }}>
                <span className={styles.cardInitial}>{(p.name || '?')[0]}</span>
              </div>
              <p className={styles.cardBrand}>{p.brand ? `@${p.brand}` : ''}</p>
              <p className={styles.cardName}>{p.name}</p>
            </button>
          ))}
        </div>
      )}

      {toast && <Toast message={toast} onDismiss={() => setToast(null)} />}
    </div>
  );
}
